export const DEBUG_SKIP_AUTH = process.env.REACT_APP_DEBUG_SKIP_AUTH === 'true';
